module.exports = new __parcel__URL__("total-methane-2020.c0f32012.png").toString();